import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import CustomToolTip from '../_tooltip';
import { tickValues, colourPalette } from '../_base';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, item, id, hasBars }) => {
    const values = data[0].data;
    const [bottomTicks, setBottomTicks] = React.useState([]);
    const [leftTicks, setLeftTicks] = React.useState([]);
    const [leftTicksExtra, setLeftTicksExtra] = React.useState({});
    const [maxY, setMaxY] = React.useState(values.reduce((p, c) => (c.y > p ? c.y : p), 0));

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        setBottomTicks(tickValues(values, 'x', me.offsetWidth));
    }, [item.w]);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        let extra = {};
        setLeftTicks(tickValues(values, 'y', me.offsetHeight, true, extra));
        setLeftTicksExtra(extra);
    }, [item.h]);

    return (
        <ResponsiveLine
            data={data}
            margin={{ top: 10, right: 70, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear' }}
            curve="monotoneX"
            axisTop={null}
            xFormat={x => e4Format(x, e4Formats.monthShort)}
            // yFormat={x => `${Math.round(x).toLocaleString()}`}
            colors={colourPalette[0]}
            axisBottom={{
                tickValues: bottomTicks,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x => e4Format(x, e4Formats.monthShort),
                legend: 'Month',
                legendOffset: 40,
                legendPosition: 'middle',
            }}
            axisLeft={{
                tickValues: leftTicks,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x => (leftTicksExtra.format ? leftTicksExtra.format(x) : x),
                legend: `Sales Velocity ${leftTicksExtra.suffix}`,
                legendOffset: -50,
                legendPosition: 'middle',
            }}
            enableGridX={false}
            enableGridY={!hasBars}
            lineWidth={1.2}
            pointSize={8}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={1}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh
            tooltip={point => <CustomToolTip point={point} legend="Sales Velocity" />}
        />
    );
};

export default Chart;
